export class GetDynamicClientEmployeeFormBO {
  orderColumn: string = "";
  currentpageno: number = 1;
  pageitem: number = 10;
  orderType: string = "asc";
  type: string = "string";
  field: string = "";
  operator: string = "contains";
  value: string = "";
  entityTypeCode: string;
  matchCase: boolean = false;
  clientId:  string = "00000000-0000-0000-0000-000000000000";
  employeeId: string = "00000000-0000-0000-0000-000000000000";
  agencyID: string | null;
  dynamicType: string;
  onboard: boolean = false;
}
export class ClientEmployeeDynamicFormBO {
  Id: string
  Dynamictype: string
  type: string;
  dynamicClientType:string=null;
}

export class SendDynamicToClientBO {
  id: string= "00000000-0000-0000-0000-000000000000";
  clientId: string;
  agencyNote: string;
  portalLink: string;
  documentLid: string;
}


export class DynamicClientFormSaveBO {
  clientId: string = "00000000-0000-0000-0000-000000000000";
  dynamicFormTemplateId: string;
  file: any;
  documentName: string = "";
  name: string = "";
  documentType: string = "";
 
}

export class GenerateDynamicClientEmployeeFormBO {
  clientId: string = "00000000-0000-0000-0000-000000000000";
  employeeId:string = "00000000-0000-0000-0000-000000000000";
  templateId:string = "00000000-0000-0000-0000-000000000000";
}  


export class DEEventEmitterBo {
  isCreate: boolean = false;
  isClose: boolean = false;
  details:any;

}



	
export class SendDynamicFormToEmployeeBO {
  id: string;
  agencyNote: string;
  employeeDocumentId: string;
  portalLink: string;
}

export class SendDynamicFormToClientBO {
  id: string;
  agencyNote: string;
  employeeDocumentId: string;
  portalLink: string;
}



export class SubmitEmployeeAggremntBo {
  type: string;
  aggrementId: string;
  employeeStatusLid: string;
}

export class OfficeNotesBO {
  officenotes: string;
  documentLid: string = "00000000-0000-0000-0000-000000000000";
}


export class functionpermission {
  DeleteDynamicTemplate: boolean = true;
}